import { TwinDictionary } from '../../../../../../../utils/globals/dictionary'

export const parseDateToDayWeekDay = (date: Date, days: TwinDictionary) => {
    return date.getDate() + ' ' + days[date.getDay()]
}

export const getHourFromTimetableDate = (date: string) => {
    return date?.split(' ')[1].split(':')
}